/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {RecipeGridCardSkeleton} from "../../recipes/RecipeGridCardSkeleton";

export const RecipeFinderRowSkeleton = () => (
    <>{[...Array(4)].map((item, i) => <RecipeGridCardSkeleton key={i}/>)}</>
)
